<template>
  <div>
    <h4>PicPay</h4>
    <div class="mt-2 mb-4">
      Um e-mail com os dados do pedido será enviado para <strong>{{ basket.email }}</strong>
    </div>

    <WhatsAppPhoneInput :basket="basket" />

    <div class="mb-2">
      <vs-input
        class="w-full"
        label="CPF/CNPJ no PicPay"
        placeholder="Somente números"
        v-model="basket.cpfcnpj"
      />
    </div>

    <vs-button type="relief" class="w-full mt-6" @click="pay">Continuar</vs-button>
  </div>
</template>

<script>
import WhatsAppPhoneInput from '../WhatsAppPhoneInput.vue';

export default {
  components: {
    WhatsAppPhoneInput
  },
  props: {
    checkoutWizard: {
      type: Object,
      required: true
    },
    paymentMethod: {
      type: String,
      required: true
    },
    basket: {
      type: Object,
      required: true
    }
  },
  methods: {
    pay() {
      this.basket.processing = true;

      this.$api
        .post('/api/v1/checkout/order/create', {
          payment_method: this.paymentMethod,
          basket: this.basket,
          affiliate: localStorage.getItem('aff') || null
        })
        .then(response => {
          if (response.data && parseInt(response.data.orderId) > 0) {
            window.location.href = response.data.url;
          } else {
            this.$vs.notify({
              time: 6000,
              text: 'Não foi possível processar seu pedido. Atualize a página e tente novamente.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'danger'
            });
            this.basket.processing = false;
          }
        })
        .catch(error => {
          this.basket.processing = false;

          let errors = [];
          if (error.response.data.message) {
            errors.push(error.response.data.message);
          } else {
            for (const key in error.response.data) {
              if (Object.hasOwnProperty.call(error.response.data, key)) {
                errors.push(error.response.data[key]);
              }
            }
          }

          this.$vs.notify({
            time: 6000,
            text: errors.join('<br>'),
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          });
        });
    }
  }
};
</script>
